import type { IntakeConfig, ResultOption } from '@/types/intake';

/**
 * Render-time mapping of the data-driven intake config to UI. The result buttons, their colors,
 * and the reason-required rule come FROM config (the Setup Summary intake_* fields), never from
 * hardcoded UI. Tailwind purges unseen classes, so color tokens map to FULL static class strings
 * here (a computed `bg-${token}` would be stripped from the build).
 */

const COLOR_CLASSES: Record<string, string> = {
  negative: 'bg-negative text-white',
  positive: 'bg-positive text-white',
  unable: 'bg-unable text-white',
};
const FALLBACK_CLASSES = 'bg-cdx-surface-2 text-cdx-fg-default';

/** Tailwind classes for a result option's button. */
export function resultButtonClasses(option: ResultOption): string {
  return COLOR_CLASSES[option.color] ?? FALLBACK_CLASSES;
}

/** The ordered button set for a config (already config-driven; this is a thin, intentional pass). */
export function resultButtons(config: IntakeConfig): ResultOption[] {
  return config.results;
}

/** A short chip class for a result code, reused by the Review list. */
export function resultChipClasses(config: IntakeConfig, result: string): string {
  const option = config.results.find((r) => r.result === result);
  return option ? `${COLOR_CLASSES[option.color] ?? FALLBACK_CLASSES} px-2 py-0.5 rounded-cdx text-xs font-semibold` : 'bg-cdx-surface-1 text-cdx-fg-muted px-2 py-0.5 rounded-cdx text-xs';
}
